module.exports = __webpack_public_path__ + "b9ce78f788678fd7e2eaf265b3aa4058.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-420.webp
// module id = 227
// module chunks = 0